import styled from 'styled-components';
import SeH004B from 'dc/SeH004B';
import ChaMeta12 from 'dc/ChaMeta12';
import { Typ32, Typ30 } from 'dc/Typ';

export const Wrapper = styled.div`
  width: 672px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: stretch;
  background-color: #fff;
  border-radius: 4px;
`;

export const Header = styled(SeH004B)`
  background-color: #f4f7f9;
`;

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 32px 0 40px 72px;
`;

export const ProgressWrapper = styled.div`
  width: 336px;
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
  height: 240px;
  overflow-y: auto;
  div div div div span:first-child {
    width: 160px;
  }
`;

export const DayProgressBar = styled(ChaMeta12)`
  width: 100%;
`;

export const StreakWrapper = styled.button`
  display: flex;
  flex-direction: column;
  border: none;
  background: #fff;
  cursor: pointer;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
  text-align: center;
`;

export const Title = styled(Typ32)`
  margin-bottom: 8px;
`;

export const Text = styled(Typ30)`
  opacity: 70%;
`;
